import { useContext, useEffect } from 'react'
import { DealerContext } from '../context/DealerContext'
import { apiGet } from '@/services/apiService'

const DealerSwitcher = () => {
  const dealerContext = useContext(DealerContext)

  useEffect(() => {
    const fetchDealerSettings = async () => {
      if (!dealerContext) {
        console.error('DealerContext is undefined')
        return
      }

      const { setDealer, setDealerBasicThemeDetails, setDealerLoadingCompleted } = dealerContext

      // Get the search params from the URL (case-insensitive)
      const searchParams = new URLSearchParams(window.location.search)
      const params: Record<string, string | null> = {}
      for (const [key, value] of searchParams.entries()) {
        params[key.toLowerCase()] = value
      }
      const uniqueIdentifier = params['uid']
      const dealerId = params['dealerid']
      const brand = params['brand']
      const previewThemeNodeId = params['previewthemenodeid']

      // Handle case when neither uniqueIdentifier, dealerId nor brand is present
      if (!uniqueIdentifier && !dealerId && !brand && !previewThemeNodeId) {
        setDealerLoadingCompleted(true)
        return
      }

      try {
        let response
        if (dealerId) {
          // Fetch dealer settings using dealerId
          response = await apiGet(`Dealer/GetDealerSettings?dealerId=${dealerId}`)
        } else if (uniqueIdentifier) {
          // Fetch dealer settings using uniqueIdentifier
          response = await apiGet(`Dealer/GetDealerSettings?uniqueIdentifier=${uniqueIdentifier}`)
        } else if (brand) {
          // Fetch dealer settings using brand
          response = await apiGet(`Dealer/FindDealersByBrand?brand=${brand}`)
        } else if (previewThemeNodeId) {
          response = await apiGet(`Dealer/FindDealersByBrand?previewThemeNodeId=${previewThemeNodeId}&isPreview=true`)
        }

        if (!response || !response.success) {
          throw new Error(`Failed to fetch dealer settings: ${response ? response.responseMessage : 'No response'}`)
        }

        const data = response.data
        if (data) {
          if (uniqueIdentifier || dealerId) {
            setDealer(data)
          } else if (brand) {
            if (data.theme) setDealerBasicThemeDetails(data.theme)
          } else if (previewThemeNodeId) {
            setDealerBasicThemeDetails(data.theme)
          }
        } else {
          console.error('Invalid theme data received from API')
        }
      } catch (error) {
        console.error('Error fetching theme settings:', error)
      } finally {
        setDealerLoadingCompleted(true)
      }
    }

    fetchDealerSettings()
  }, [dealerContext])

  return null
}

export default DealerSwitcher
